module.exports = __webpack_public_path__ + "static/img/protection-thumb.a18d32f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protection-thumb.jpg
// module id = 39
// module chunks = 0